import type { ReactNode } from 'react';

import { Horizontal } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';
import { Chip } from 'atoms/ui/Chip';

type Props = { amount: number; icon: ReactNode };

export const CurrencyBalance = ({ amount, icon }: Props) => {
  return (
    <Chip size="medium">
      <Horizontal gap={0.5}>
        {icon}
        <LabelM bold>{amount}</LabelM>
      </Horizontal>
    </Chip>
  );
};
